import { render } from "./Drepturi.vue?vue&type=template&id=8591de0e"
import script from "./Drepturi.vue?vue&type=script&lang=js"
export * from "./Drepturi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__